import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Modal from "@mui/material/Modal";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import {
  ErrorMsgDetail,
  GetItemFullSearchArr,
  fItemCodeDependency,
  GetSearchItem,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  GetUnitArr,
  GetPoTypeArr,
  fValidationDetail_Client,
  // fValidationHead_Client,
  //item
  GCToggleSearch_ItemName_Columns,
  GCToggleSearch_ItemName_Select_Arr,

  //save
  fSaveHead,
  fLoad_Grid,
  fApproveHead_Server,
  MultiCardFlag,
  fValidationHead_Client,
} from "./CyclecountAction";
import {
  fAlertToast,
  fcovertToNumber,
  GetCheck_Monthend_DueDate,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
  Get_ToggleDropDown_binsearch_Load,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "../../Server/Apis";
import { Set_SliceCyclecount_HeadObj } from "./SliceCyclecount";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import CyclecountBreadcrumbs from "./Cyclecount_BreadCrumbs";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./Cyclecount.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { CyclecountDetailTblCard } from "./processComponent/CyclecountDetailTblCard";
import { CycleCount_delete_API } from "../../Server/ApiV2";
import PrintModal from "./processComponent/PrintModal";
import GCMultipleCard from "../Notification/component/GCMultipleCard";

export default function CyclecountDetail() {
  const dispatch = useDispatch();
  const BarcodeFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const Detail_Grid_columns = [
    {
      field: "B_SheetId",
      headerName: "Sheet No",
      width: 150,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "B_SrNo",
      headerName: "Sr No",
      width: 50,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "B_CardID",
      headerName: "CardID",
      width: 150,
    },
    {
      field: "BinName",
      headerName: "BinName",
      width: 300,
    },
    {
      field: "B_Qty",
      headerName: "Qty",
      width: 50,
    },
    {
      field: "B_ItmCd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 320,
    },

    {
      field: "B_Unit",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "B_BaseQty",
      headerName: "Base Qty",
      width: 100,
      hide: vMediaQuery ? true : false,
    },
  ];
  const vRdxHead = useSelector((state) => state.SliceCyclecount.value.HeadObj);
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
  const [sPoTypeArr, setPoTypeArr] = useState([]);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const vInitHeadError = {
    SheetNo: "",
    Loc: "",
    LocName: "",
    Date: "",
    ReferenceNo: "",
  };
  const [sErrorMsg, setErrorMsg] = useState(vInitHeadError);
  const fLocation = async (e) => {
    dispatch(
      Set_SliceCyclecount_HeadObj({
        ...vRdxHead,
        Loc: e.target.value,
      })
    );
  };
  const fReferenceNo = async (e) => {
    dispatch(
      Set_SliceCyclecount_HeadObj({
        ...vRdxHead,
        ReferenceNo: e.target.value,
      })
    );
  };

  const fReferenceNo_Enter = (e) => {
    if (e.key === "Enter") {
      document.getElementsByName("B_CardId")[0]?.focus();
    }
  };

  const fDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_SliceCyclecount_HeadObj({
          ...vRdxHead,
          Date: "",
        })
      );
    } else {
      dispatch(
        Set_SliceCyclecount_HeadObj({
          ...vRdxHead,
          Date: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_SliceCyclecount_HeadObj({
    //     ...vRdxHead,
    //     Date: event.$d,
    //   })
    // );
  };

  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  const [sDetail_Grid_Row, setDetail_Grid_Row] = useState([]);

  const sRoundingVal = 4;
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.B_SrNo,
      B_CardId: item.row.B_CardID,
      B_Itmcd: item.row.B_ItmCd,
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.B_Qty,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_ItmCd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue.PackDesc,
    }));
    fCloseViewModal();
  };

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_CardId: "",
    B_Itmcd: "",
    B_ItmName: "",
    RefNo: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
  };

  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  const [sUnit, setUnit] = useState([]);
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };
  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("B_Qty")[0].blur();
    }
  };
  const fCardId = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_CardId: e.target.value,
    }));
  };
  const fCardId_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: "",
      B_ItmName: "",
      B_Unit: "",
      B_PackQty: 0,
      B_BaseQty: 0,
      B_Packing: 0,
    }));
    setUnit([]);
  };

  //API NOTIFICATION_PICKINGCARDIDSEARCH_GETROW
  const GetCartIDDetail = async (xCardId) => {
    const CartBarcodeDetailObj = {
      CardId: xCardId,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "NOTIFICATION_PICKINGCARDIDSEARCH_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: CartBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: CartBarcodeDetail.ResultSet[0].Name2,
          B_CardId: CartBarcodeDetail.ResultSet[0].CardID,
        }));

        let vItemSearchFull = await GetItemFullSearchArr(
          CartBarcodeDetail.ResultSet[0].ItmCd,
          vRdxHead.Loc
        );

        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            setBufferObj,
            setUnit,
            CartBarcodeDetail.ResultSet[0].Unit
          );
        }
      } else {
        fCardId_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else {
      fAlertToast(
        "FAILED",
        CartBarcodeDetail.response.data.message || CartBarcodeDetail?.Message
      );
    }
  };
  const GetBarcodeDetail = async (xBarcode, xeditRow) => {
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_Loc: vRdxHead.Loc,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_TRANSFER_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: vBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: vBarcodeDetail.ResultSet[0].Name2,
          B_CardId: vBarcodeDetail.ResultSet[0].CardID,
          // RefNo: vBarcodeDetail.ResultSet[0]?.SuppRefNo1,
        }));
        let vItemSearchFull = await GetItemFullSearchArr(
          vBarcodeDetail.ResultSet[0].ItmCd,
          vRdxHead.Loc
        );

        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            setBufferObj,
            setUnit,
            vBarcodeDetail.ResultSet[0].Unit
          );
        }

        setTimeout(() => {
          document.getElementById("Qty")?.focus();
        }, 100);
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: "",
          B_ItmName: "",
          // CardId: "",
          B_Unit: "",
        }));
        fAlertToast("WARNING", "Wrong barcode Id");
      }
    } else {
      fAlertToast(
        "FAILED",
        vBarcodeDetail.Message ||
          vBarcodeDetail.response.data.message ||
          "Error in Loading Barcode "
      );
    }
  };

  //MultipleCard start
  const [sMultipleCardModal, setMultipleCardModal] = useState(false);
  const [sMultipleCardData, setMultipleCardData] = useState([]);

  const fOpenMultipleCardModal = () => {
    setMultipleCardModal(true);
  };
  const fMultipleCard = async (e) => {
    // const { HeadObject } = InboundGrn();
    // await GetMultipleCard(
    //   HeadObject.A_RefDocNo,
    //   HeadObject.A_RefDocTyp,
    //   setMultipleCardData

    // );
    fOpenMultipleCardModal();
  };
  const fCloseMultipleCardModal = (e) => {
    setMultipleCardModal(false);
  };
  //MultiCard end
  const GetMultiBarcodeDetail = async (xBarcode, xBinCd, xeditRow) => {
   
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_BinCd: xBinCd,
      v_Loc: vRdxHead.Loc,
    
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_MULTI_BARCODE_DETAILS_CycleCount",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length == 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: "",
          B_ItmName: "",
          // CardId: "",
          B_Unit: "",
        }));
        fAlertToast("WARNING", "Wrong barcode Id");
      } else if (vBarcodeDetail.ResultSet.length == 1) {
        GetCartIDDetail(vBarcodeDetail?.ResultSet[0]?.CARDID, false);
      } else if (vBarcodeDetail.ResultSet.length > 1) {
        setMultipleCardData(vBarcodeDetail.ResultSet);
        fMultipleCard();
      }
    } else {
      fAlertToast(
        "FAILED",
        vBarcodeDetail.response.data.message ||
          vBarcodeDetail.Message ||
          "Error in Loading MultiBarcode "
      );
      return;
    }
  };

  const fCardIdEnter = async (e) => {
    if (e.key === "Enter") {
      if (sBufferObj.B_CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      }
      if (vRdxHead.BinCd == "" || vRdxHead.BinName == "") {
        fAlertToast("FAILED", "BinCode is empty");
        setTimeout(() => {
          document.getElementsByName("BinName")[0]?.focus();
        }, 100);
      } else if (MultiCardFlag()) {
        await GetMultiBarcodeDetail(sBufferObj.B_CardId, vRdxHead.BinCd, false);
      } else {
        if (vRdxHead.BinCd !== "" && vRdxHead.BinName !== "") {
          const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load(
            vRdxHead.BinName,
            "Any",
            "Y",
            vRdxHead.Loc
          );
          if (vReasonWmBin.length > 0 && vReasonWmBin[0]?.OpenBin == "Y") {
            GetBarcodeDetail(sBufferObj.B_CardId, false);
          } else {
            GetCartIDDetail(sBufferObj.B_CardId, false);
          }
        }
      }
      // else {
      //   GetCartIDDetail(sBufferObj.B_CardId);
      // }
    } else if (e.key === "Backspace") {
      fCardId_BackSpace_Clear();
    }
  };

  //Modal ItemSearch start
  const [
    GCToggleSearch_ItemName_Grid_Row,
    set_GCToggleSearch_ItemName_Grid_Row,
  ] = useState([]);
  //Item Dropdowm
  const [GCToggleSearch_ItemName_Toggle, set_GCToggleSearch_ItemName_Toggle] =
    useState(false);
  const [GCToggleSearch_ItemName_Obj, set_GCToggleSearch_ItemName_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const Toggle_ItemSearch = () => {
    if (GCToggleSearch_ItemName_Toggle) {
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      set_GCToggleSearch_ItemName_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      set_GCToggleSearch_ItemName_Toggle(true);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  const GCToggleSearch_ItemName_Sub_Input = (e) => {
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fItemToggleClick = (e) => {
    set_GCToggleSearch_ItemName_Grid_Row([]);
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }

    Toggle_ItemSearch();
  };

  //ItemSearch
  const GCToggleSearch_ItemName_Main_Enter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxHead.Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
      }));
      setUnit([]);
    }
  };

  //Item search Start
  const GCToggleSearch_ItemName_Main_Input = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const GCToggleSearch_ItemName_RowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd, vRdxHead.Loc);
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    set_GCToggleSearch_ItemName_Toggle(false);
  };
  //GCItemSearch
  const GCToggleSearch_ItemName_CellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_ItemName_RowClick(newSelectionModel);
    }
  };
  const GCToggleSearch_ItemName_Sub_Enter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        GCToggleSearch_ItemName_Obj.Data,
        GCToggleSearch_ItemName_Obj.Type,
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  //Item search end

  //Bin start

  const xfGC_Toggle_Head_BinName_Name = (e) => {
    dispatch(
      Set_SliceCyclecount_HeadObj({
        ...vRdxHead,
        BinName: e.target.value,
      })
    );
  };

  const [
    sGC_Toggle_Head_BinName_SearchDropdownObj,
    setGC_Toggle_Head_BinName_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [sGC_Toggle_Head_BinName_GridData, setGC_Toggle_Head_BinName_GridData] =
    useState([]);
  const [
    sGC_Toggle_Head_BinName_ToggleDropDowm,
    setGC_Toggle_Head_BinName_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_BinName_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_GridData([]);
      setGC_Toggle_Head_BinName_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_BinName_ToggleDropDowm(true);
      set_GCToggleSearch_ItemName_Toggle(false);
    }
  }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);

  //1stcall
  const fGC_Toggle_Head_BinName_onKeyUp = async (e) => {
    // fBinNameKey(e);
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (vRdxHead.BinName == "") {
        fAlertToast("FAILED", "BinName is empty");
        return;
      }
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        vRdxHead.BinName,
        "Any",
        "Y",
        vRdxHead.Loc
      );

      if (vExactSearch.length > 0) {
        dispatch(
          Set_SliceCyclecount_HeadObj({
            ...vRdxHead,
            BinCd: vExactSearch[0].UId,
            BinName: vExactSearch[0].Name1,
          })
        );
        setTimeout(() => {
          const element = document.querySelector('[tabindex="101"]');
          element?.focus();
        }, 100);
      } else {
        fAlertToast("FAILED", "Wrong Bin Name");
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Set_SliceCyclecount_HeadObj({
          ...vRdxHead,
          BinCd: "",
        })
      );
    }
  };

  //Bin end
  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxHead?.A_DocStat !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxHead?.A_DocStat + " mode"
        );
        return;
      }

      let validationHead = fValidationHead_Client(vRdxHead);
      if (!validationHead) return;

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );

      if (!validationDetil) return;

      fSaveHead(fNewDetail, sBufferObj, dispatch);
    }, 500);
  };

  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd !== "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetail_Grid_Row.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }

      // let CheckDueDate = await GetCheck_Monthend_DueDate(
      //   vRdxHead.Loc,
      //   vRdxHead.Date
      // );
      // if (!CheckDueDate) return;

      fApproveHead_Server(dispatch, "Y");
    }, 500);
  };

  const fVariance = () => {
    fApproveHead_Server(dispatch, "N");
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vInitHeadError);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_CardId == "" && sBufferObj.B_Srno == 0) {
      dispatch(
        Set_SliceCyclecount_HeadObj({
          SheetNo: 0,
          Loc: vRdxDBLocation[0]?.UID,
          LocName: vRdxDBLocation[0]?.Name1,
          Date: new Date(),
          ReferenceNo: "",
          A_DocStat: "ENTER",
        })
      );
      fNewDetail();
      document.getElementsByName("Date")[0]?.focus();
    } else {
      fNewDetail();
    }
  };
  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  const fNewDetail = () => {
    setBufferObj(vBufferObjInit);

    setUnit([]);

    fLoad_Grid(setDetail_Grid_Row);

    document.getElementsByName("B_CardId")[0]?.focus();
  };

  const fDelete = (e) => {
    if (vRdxHead.A_DocStat === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (sBufferObj.B_Srno === 0) {
      fAlertToast("FAILED", "Item is not selected");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // DELETESIHEAD_GETROW

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    let vDeleteSIDetailObj = {
      v_B_SheetId: vRdxHead.SheetNo,
      v_B_SrNo: sBufferObj.B_Srno,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const Resp = await CycleCount_delete_API(FinalObj);
    console.log("res", Resp);
    if (Resp?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail();
    }
  };
  const [printOpenModal, setPrintOpenModal] = useState(false);
  const fPrint = () => {
    setPrintOpenModal(true);
  };

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      setGC_Toggle_Head_BinName_GridData([]);
    }
  }, []);

  useEffect(() => {
    GetPoTypeArr(setPoTypeArr);
  }, []);

  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty: fcovertToNumber(sBufferObj.B_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);

  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty: fcovertToNumber(sBufferObj.B_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    fLoad_Grid(setDetail_Grid_Row);
  }, []);

  useEffect(() => {
    BarcodeFocusOnLoad?.current?.focus();
  }, []);

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  useEffect(() => {
    GetGitterColumns(
      setSummaryGridColumn2,
      "WMPOIPT01_DETAIL",
      Detail_Grid_columns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid ">
      <div className="Breadcrumbs">
        <CyclecountBreadcrumbs />
      </div>
      <div className="Cyclecount-detail">
        {vMediaQuery ? (
          " "
        ) : (
          <WmsHead
            xref={BarcodeFocusOnLoad}
            vRdxHead={vRdxHead}
            xErrorMsg={sErrorMsg}
            vRdxuserLoc={vRdxDBLocation}
            fLocation={fLocation}
            fReferenceNo={fReferenceNo}
            fReferenceNo_Enter={fReferenceNo_Enter}
            fDate={fDate}
            PoTypeArr={sPoTypeArr}
            sDetail_Grid_Row={sDetail_Grid_Row}
            xfGC_Toggle_Head_BinName_Name={xfGC_Toggle_Head_BinName_Name} //onchange main input
            xGC_Toggle_Head_BinName_onKeyUp={fGC_Toggle_Head_BinName_onKeyUp} //main input enter
            sEnterKeyObj={sEnterKeyObj}
            vMediaQuery={vMediaQuery}
          />
        )}

        <WmsContent
          sEnterKeyObj={sEnterKeyObj}
          vMediaQuery={vMediaQuery}
          xContent_Focus={fContent_Focus}
          xContent_Blur={fContent_Blur}
          xErrorMsgDetail={sErrorMsgDetail}
          xBufferObj={sBufferObj}
          sUnit={sUnit}
          fUnit={fUnit}
          fQty={fQty}
          fQty_Enter={fQty_Enter}
          fCardId={fCardId}
          fCardIdEnter={fCardIdEnter}
          //GC toggle
          fItemName={GCToggleSearch_ItemName_Main_Input} //onchange main input
          xMediaQuery={vMediaQuery} //mobile screen
          xonClickbtn={GCToggleSearch_ItemName_Main_Enter} // onclick icon open div on main screen

          //customer
        />
        <Grid
          container
          className="my-2"
          spacing={{ xs: 1, sm: 1, md: 0.5 }}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{
            alignItems: "center",
            justifyContent: vMediaQuery ? "start" : "center",
          }}
        >
          <Grid item xs={4} sm={4} md={4} sx={{ textAlign: "center" }}>
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId={"IdNew"}
              xSendIcon={<AddBoxRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} sx={{ textAlign: "center" }}>
            <CmpButton
              xbtnName="Save"
              xOnClick={fSave}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId={"IdSave"}
              xSendIcon={<SaveRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} sx={{ textAlign: "center" }}>
            <CmpButton
              xbtnName="Delete"
              xOnClick={fDelete}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId="IdDelete"
              xSendIcon={<DeleteRoundedIcon />}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            sx={{ textAlign: "center" }}

            // className="xs-dontShowInMobileView"
          >
            <CmpButton
              xbtnName="Variance"
              xOnClick={fVariance}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            sx={{ textAlign: "center" }}

            // className="xs-dontShowInMobileView"
          >
            <CmpButton
              xbtnName="Approve"
              xOnClick={fApprove}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId={"IdApprove"}
              xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            sx={{ textAlign: "center" }}
            className="xs-screen-hide"
          >
            <CmpButton
              xbtnName="Print"
              xOnClick={() => {
                fPrint();
              }}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId="IdPrint"
              xSendIcon={<LocalPrintshopIcon />}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            sx={{ textAlign: "center" }}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Detail"
              xOnClick={fView}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            sx={{ textAlign: "center" }}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Summary"
              xOnClick={fSummary}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid>
        </Grid>
        <div className="mt-5 xs-screen-hide">
          <Box sx={{ height: "35vh", width: "100%" }}>
            <CyclecountDetailTblCard
              data={sDetail_Grid_Row}
              onClick={fDetail_Grid_onRowClick}
            />
          </Box>
        </div>
      </div>
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View "} onClose={fCloseViewModal} />

          <div className="py-2">
            <div style={{ height: "70vh", width: "100%" }}>
              <CyclecountDetailTblCard
                data={sDetail_Grid_Row}
                onClick={fDetail_Grid_onRowClick}
              />
            </div>
          </div>
        </Box>
      </Modal>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance ">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-2">
            <WmsHead
              xref={BarcodeFocusOnLoad}
              vRdxHead={vRdxHead}
              xErrorMsg={sErrorMsg}
              vRdxuserLoc={vRdxDBLocation}
              fLocation={fLocation}
              fReferenceNo={fReferenceNo}
              fReferenceNo_Enter={fReferenceNo_Enter}
              fDate={fDate}
              PoTypeArr={sPoTypeArr}
              sDetail_Grid_Row={sDetail_Grid_Row}
            />
          </div>
        </Box>
      </Modal>

      {/* print modal  */}
      <PrintModal
        fCloseModal={() => {
          setPrintOpenModal(false);
        }}
        open={printOpenModal}
        xTitle="Variance"
      />
      <GCMultipleCard
        xOpen={sMultipleCardModal}
        fCloseDetailModal={fCloseMultipleCardModal}
        sMultipleCard={sMultipleCardData}
        xTitle={"Card Detail"}
        onClickMultipleCard={(obj) => {
          GetCartIDDetail(obj.CARDID, false);
        }}
      />
    </div>
  );
}
